import React from "react";
import { formatDate, FormatValueDecimal, CurrencyConvertion } from "../../utils/Validate";
import { NotFound } from "../../components/common/NotFound";
import QuotationReferenceRowSkeleton from "./QuotationReferenceRowSkeleton";
import QuotationRowActions from "./QuotationRowActions";
import QuotationStatusCell from "./QuotationStatusCell";

const QuotationGeneralViewGrid = (params) => {
  const {
    currentTableData,
    handleEdit,
    handleDelete,
    handleStatusOpen,
    handleForecast,
    HandleCopyQuote,
    HandleConvertJIH,
    menuRights,
    currencyList,
    quotationStatus,
    loading,
    handleQuotationStatusUpdate,
    isProjectScoped = false,
  } = params;

  const HandleOpenPDFSummary = (item) => {
    const url = `/pdf-summary?id=${item?.id}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const worklistClassName = `quote-reference-worklist ${
    isProjectScoped ? "quote-reference-worklist--project-scoped" : "quote-reference-worklist--all-projects"
  }`;

  return (
    <>
      {loading ? (
        <div className={worklistClassName}>
          <div className="quote-reference-header">
            <div>Quote Ref</div>
            <div>Customer</div>
            {!isProjectScoped && <div>Project</div>}
            <div>Sales Engineer</div>
            <div>Date</div>
            <div className="amount-cell">Quote Value</div>
            <div>Status</div>
            <div aria-label="Actions"></div>
          </div>
          {[...Array(10)].map((_, index) => (
            <QuotationReferenceRowSkeleton key={index} rowIndex={index} isProjectScoped={isProjectScoped} />
          ))}
        </div>
      ) : currentTableData?.length > 0 ? (
        <div className={worklistClassName}>
          <div className="quote-reference-header">
            <div>Quote Ref</div>
            <div>Customer</div>
            {!isProjectScoped && <div>Project</div>}
            <div>Sales Engineer</div>
            <div>Date</div>
            <div className="amount-cell">Quote Value</div>
            <div>Status</div>
            <div aria-label="Actions"></div>
          </div>

          {currentTableData?.map((item, index) => {
            return (
              <div
                className={`quote-reference-row ${index % 2 === 0 ? "row-even" : "row-odd"}`}
                key={`${item?.id || item?.quoteReference || "quote"}-${index}`}
              >
                <div
                  className="quote-ref-cell"
                  onClick={menuRights?.canEdit ? () => handleEdit(item) : undefined}
                  title={item?.quoteReference}
                >
                  <span>{item?.quoteReference}</span>
                </div>
                <div className="quote-customer-cell" title={item?.customerName}>{item?.customerName}</div>
                {!isProjectScoped && (
                  <div className="quote-project-name-cell" title={item?.projectName}>{item?.projectName}</div>
                )}
                <div className="quote-sales-cell" title={item?.salesEngineerName || item?.salesEngineer}>
                  {item?.salesEngineerName || item?.salesEngineer}
                </div>
                <div className="quote-date-cell">{formatDate(item?.createdAt)}</div>
                <div className="amount-cell">
                  {FormatValueDecimal(
                    CurrencyConvertion(
                      item?.grandTotal,
                      item?.conversionRate,
                      currencyList?.find((c) => c?.id === item?.currencyId)
                    ) || 0
                  )}
                </div>
                <div className="quote-status-cell">
                  <QuotationStatusCell
                    item={item}
                    quotationStatus={quotationStatus}
                    handleStatusOpen={handleStatusOpen}
                    handleQuotationStatusUpdate={handleQuotationStatusUpdate}
                  />
                </div>
                <div className="quote-action-cell">
                  <QuotationRowActions
                    item={item}
                    menuRights={menuRights}
                    handleForecast={handleForecast}
                    handlePrint={HandleOpenPDFSummary}
                    handleCopy={HandleCopyQuote}
                    handleConvert={HandleConvertJIH}
                    handleDelete={handleDelete}
                  />
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <NotFound />
      )}
    </>
  );
};

export default QuotationGeneralViewGrid;
